import { Box, Flex, Text, useMediaQuery } from '@chakra-ui/react';
import { ReactNode } from 'react';

import Container from 'components/Container';
import Logo from 'components/Icons/Logo';
import LoginImage from 'components/Icons/LoginImage';

interface Properties {
  title: string;
  description?: ReactNode;
  children: ReactNode;
}

const AuthenticationMfaShell = ({ title, description, children }: Properties) => {
  const [isMobile] = useMediaQuery('(max-width: 576px)');

  return (
    <Container
      wrapperProperties={{
        px: 0,
        p: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        height: '100%',
      }}
      bgColor={'linear-gradient(180deg, rgba(101, 98, 207, 0.6) 0%, rgba(75, 182, 185, 0.6) 100%);'}
    >
      <Flex
        boxShadow={'0px 15px 15px rgba(0, 0, 0, 0.15)'}
        borderRadius={'15px'}
        bgColor={'white'}
        width={'fit-content'}
        minWidth={isMobile ? '300px' : '42rem'}
        position='relative'
        overflow={'hidden'}
      >
        <Flex
          maxWidth={isMobile ? '100%' : '38rem'}
          width='100%'
          padding={isMobile ? '2rem' : '2rem 0 2rem 3rem'}
          direction='column'
        >
          <Box data-testid='mfa-auth-shell'>
            <Logo height={10} width={'auto'} />
          </Box>
          <Text
            variant='secondary'
            fontFamily='bold'
            fontSize={{ base: '20px', '1.5xl': '25px' }}
            width={{ start: '70%', laptop: '100%' }}
            marginTop='2rem'
            color='#121826'
          >
            {title}
          </Text>
          {description ? (
            <Text
              variant='secondary'
              marginTop='1rem'
              marginBottom='1rem'
              color='#1A202C'
              fontFamily='regular_roboto'
              fontSize='md'
              lineHeight='1.5'
              maxW={isMobile ? '100%' : '70%'}
            >
              {description}
            </Text>
          ) : null}
          <Box maxWidth='300px'>{children}</Box>
        </Flex>
        <Box position='absolute' top={0} right={0} lineHeight={0}>
          <LoginImage
            width={{ start: '180px', sm: '200px' }}
            height={{ start: '180px', sm: '200px' }}
            styles={{ borderTopRightRadius: '15px', display: 'block' }}
          />
        </Box>
      </Flex>
    </Container>
  );
};

export default AuthenticationMfaShell;
